import React from 'react';
import styled from 'styled-components';
import { TextField } from '../../fields/TextField';
import { SmartformElementData } from '../../types';
import { getElementFields } from '../../forms/utils/getElementFields';
import MultiColumns from '../../forms/layouts/MultiColumns';
import { filterNotEmpty } from '../../forms/utils/listHelpers';

export const FirstLastName: React.FC<SmartformElementData> = (props) => {
  const {
    required: [first, last],
    optional: { middleName, secondaryLastName }
  } = getElementFields<2>(props);

  return (
    <div>
      <StyledNameField>
        <TextField
          name={first.name}
          helperText={first.helpText}
          infoText={first.infoText}
          placeholder={first.hint}
          label={first.label}
          required={first.validation.required}
        />
      </StyledNameField>
      {middleName && (
        <StyledNameField>
          <TextField
            name={middleName.name}
            helperText={middleName.helpText}
            placeholder={middleName.hint}
            label={middleName.label}
            required={middleName.validation.required}
          />
        </StyledNameField>
      )}
      <MultiColumns
        xs={[12, 12]}
        elements={filterNotEmpty([
          <StyledNameField key={last.name}>
            <TextField
              name={last.name}
              helperText={last.helpText}
              placeholder={last.hint}
              label={last.label}
              type="text"
              required={last.validation.required}
            />
          </StyledNameField>,
          secondaryLastName && (
            <StyledNameField key={secondaryLastName.name}>
              <TextField
                name={secondaryLastName.name}
                helperText={secondaryLastName.helpText}
                placeholder={secondaryLastName.hint}
                label={secondaryLastName.label}
                required={secondaryLastName.validation.required}
              />
            </StyledNameField>
          )
        ])}
      />
    </div>
  );
};

const StyledNameField = styled.div`
  margin: 0 0 8px 0;
`;
